import { CustomError } from '../../../lib/custom-error';
import { QuestionType, type Question } from '../../types';

export class StartQuestionNotFoundError extends CustomError {
  constructor(...args: ConstructorParameters<typeof CustomError>) {
    super(...args);
  }
}

export const findStartQuestion = (questions: Question[]) => {
  const startQuestion = questions.find((q) => q.question_number === 1 && q.question_type === QuestionType.Question);
  if (!startQuestion) {
    throw new StartQuestionNotFoundError();
  }
  return startQuestion;
};
